export default __webpack_public_path__ + "static/media/boomoleGame.ee8360ae.png";